import { render } from "./MaskingUser.vue?vue&type=template&id=223d127d&scoped=true"
import script from "./MaskingUser.vue?vue&type=script&lang=js"
export * from "./MaskingUser.vue?vue&type=script&lang=js"

import "./MaskingUser.vue?vue&type=style&index=0&id=223d127d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-223d127d"

export default script